var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP22On(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 124.773,
    height: 45.227,
    viewBox: "0 0 124.773 45.227",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 396"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 33",
    fill: "#828896"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 240",
    d: "M62.123 32.517v3.309h-6.959q2.737-2.225 5.733-4.763a51.074 51.074 0 005.5-5.42 30.206 30.206 0 004.136-6.046 14.36 14.36 0 001.626-6.646q0-6.388-3.993-9.669T56.073 0a48.1 48.1 0 00-5.506.314 44.058 44.058 0 00-5.105.885q-2.4.571-4.164 1.169a25.689 25.689 0 00-3.251 1.34v13.52h11.409v-2.852a4.505 4.505 0 01.97-3.223 4.737 4.737 0 015.819 0 4.508 4.508 0 01.97 3.223 7.015 7.015 0 01-1.484 3.565 43.382 43.382 0 01-4.165 5.077q-2.681 2.881-6.388 6.274t-8.158 7.159v8.729h36.224V32.517z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 241",
    d: "M36.225 45.182V32.517H25.103v3.309h-6.96q2.738-2.225 5.734-4.763a51.254 51.254 0 005.5-5.42 30.24 30.24 0 004.136-6.047 14.358 14.358 0 001.626-6.645q0-6.389-3.994-9.669T19.051.001a48.078 48.078 0 00-5.5.314 43.8 43.8 0 00-5.105.885q-2.4.57-4.164 1.169a25.749 25.749 0 00-3.252 1.34v13.52h11.409v-2.852a4.508 4.508 0 01.97-3.223 4.738 4.738 0 015.819 0 4.508 4.508 0 01.97 3.223 7.019 7.019 0 01-1.483 3.565 43.581 43.581 0 01-4.164 5.077Q11.87 25.9 8.162 29.294t-8.157 7.16v8.729z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 242",
    d: "M102.676 44.969V22.157c0-1.428 1.667-2.38 2.937-2.38s2.1.516 3.491 2.3l9.958 12.775V24.458c0-1.586.873-4.4 5.713-4.4v22.573a2.4 2.4 0 01-2.6 2.6c-1.25 0-1.924-.1-3.867-2.559s-9.839-12.259-9.839-12.259v10.751c-.002 2.218-2.54 3.805-5.793 3.805z",
    fill: "#828896"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 34",
    fill: "#828896"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 243",
    d: "M92.229 19.323v5.047c.6 0 1.562.605 1.562 2.418v11.03a3.008 3.008 0 01-2.871 2.871h-5.477a3.008 3.008 0 01-2.867-2.871V26.789c0-1.813.957-2.418 1.562-2.418v-5.047c-2.922 0-7.354 1.118-7.354 7.566v11.183c0 4.634 2.922 7.153 11.284 7.153l.118-.191.119.191c8.362 0 11.284-2.519 11.284-7.153V26.889c-.005-6.448-4.439-7.566-7.36-7.566z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 244",
    d: "M90.044 31.927a.907.907 0 01-.907.906h-1.914a.906.906 0 01-.907-.906v-14.44a.906.906 0 01.907-.906h1.914a.906.906 0 01.907.906z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 35"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 245",
    d: "M.004 19.057a24.792 24.792 0 014.094-.279 6.3 6.3 0 014.094 1.093 3.794 3.794 0 011.431 3.081 4.147 4.147 0 01-1.232 3.18 6.306 6.306 0 01-4.354 1.411 5.181 5.181 0 01-1.033-.079v4.81h-3V19.057zm3 6.082a4.462 4.462 0 001.014.08c1.61 0 2.6-.814 2.6-2.166 0-1.233-.854-1.968-2.384-1.968a5.4 5.4 0 00-1.232.1z",
    fill: "#828896"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP22On);
export default __webpack_public_path__ + "static/media/p22on.7dc8cae5832574a1b223a8cf99357b55.svg";
export { ForwardRef as ReactComponent };